import { createContext, useContext } from 'react';
import useStore from 'app/store';

export interface CreationDraftScope {
    accountKey: string;
    draftId: string;
    generation: number;
}

export const CreationDraftScopeContext = createContext<CreationDraftScope | undefined>(undefined);
export const useCreationDraftScope = () => useContext(CreationDraftScopeContext);

export class CreationDraftScopeError extends Error {
    constructor(public readonly outcome: 'stale-dispatch' | 'stale-completion') {
        super(outcome === 'stale-dispatch'
            ? 'The draft request changed before the operation could start.'
            : 'The operation completed for a previous draft. Current fields were not modified.');
    }
}

export const isCurrentCreationDraftScope = (scope: CreationDraftScope): boolean => {
    const state = useStore.getState();
    return state.activeCreationDraftAccountKey === scope.accountKey
        && state.activeCreationDraftId === scope.draftId
        && state.creationDraftGeneration === scope.generation;
};

export const creationDraftCredential = (accountKey: string): string | undefined => {
    const state = useStore.getState();
    const credential = state.creationDraftCredential;
    return credential?.accountKey === accountKey && credential.token
        && credential.token === state.accessToken
        && credential.token === localStorage.getItem('accessToken') ? credential.token : undefined;
};
